// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home .van-grid-item__content:after{display:none}.home .van-icon__image{width:1.5em;height:1.5em}.home .activate-popup .van-popup{width:80%}.home .activate-popup .van-popup .card-info .van-field__label{text-align:left}.home .verification-popup .van-popup{width:80%}.home .verification-popup .van-popup .card-info .van-field__label{text-align:left}.home .activate-btn .van-button{width:90px}", ""]);
// Exports
module.exports = exports;
